import * as Yup from 'yup';

import { Fields } from 'common/types';
import { combineSchemas } from 'common/utils';

export type RemoveAccountFields = {
  email: string;
};

export const fields: Fields<RemoveAccountFields> = {
  email: {
    name: 'email',
    label: 'e-mail',
    schema: Yup.string().required().email(),
  },
};

export const validationSchema = Yup.object().shape<RemoveAccountFields>(
  combineSchemas(fields),
);
